import React, { useEffect, useRef, useState } from "react";
import Navbar from "react-bootstrap/Navbar";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { Button } from "react-bootstrap";
import preloadimg from "../../assets/img/preloader1.gif";
import uiConfig from "../../config/uiConfig";
import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import EditNoteIcon from "@mui/icons-material/EditNote";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import LogoutIcon from "@mui/icons-material/Logout";
import DescriptionIcon from "@mui/icons-material/Description";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  FaUsersCog,
  FaUserPlus,
  FaShieldAlt,
  FaThLarge,
} from "react-icons/fa";
import $ from "jquery";
import "bootstrap/dist/css/bootstrap.min.css";
import ChatRoomNew from "../comments/Comments";
import { useNavigate, Link } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import Notifications from "../notifications/Notifications";
import Bookmark from "../bookmark/Bookmark";
import { expandSidebar, collapseSidebar } from "./sidebarLayout";
import { useNavHeader } from "../../hooks/useNavHeader";
import { useUserAssignedPages } from "../../context/UserAssignedPagesContext";
import { getToken } from "../auth/authConfig";

const NavHeader = ({ title, guid, reportId, pageName, groupId, onclickmenu, pageLoad }) => {
  const {
    fetchUserGroupList,
    fetchUserDetails,
    updateDefaultUserGroup,
    updateDefaultRlType,
  } = useNavHeader();
  const { pageKeys: assignedPageKeys, features: featureFlags, ensureLoaded } = useUserAssignedPages();

  const [Switching, setSwitching] = useState(false);
  const [CheckGroupId, setCheckGroupId] = useState([]);
  const [openDialog, setopenDialog] = useState(false);
  const [personaId, setpersonaId] = useState();
  const [personaName, setpersonaName] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);
  const { instance } = useMsal();
  const menuRef = useRef(null);

  const menubar = () => {
    var sideBar = document.getElementById("mySidenav").style.width;
    if (sideBar === "" || sideBar === "80px") {
      expandSidebar();
    } else {
      collapseSidebar();
    }
  };



  useEffect(() => {
    if (onclickmenu === true) {
      expandSidebar();
    }
  }, [onclickmenu]);

  const notifications = () => {
    const x = document.getElementById("NotificationsIdValues");
    if (x.style.display === "") {
      $("#NotificationsIdValues").toggle(0);
      $("#main").css("marginRight", `${panelWidth}px`);
      document.documentElement.style.setProperty("--comments-panel-offset", `${panelWidth}px`);
    } else if (x.style.display === "none") {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", `${panelWidth}px`);
      document.documentElement.style.setProperty("--comments-panel-offset", `${panelWidth}px`);
    } else {
      $("#NotificationsIdValues").toggle();
      $("#main").css("marginRight", "6px");
      document.documentElement.style.setProperty("--comments-panel-offset", "0px");
    }
  };

  // Resizable panel width, dragged via the handle on the panel's left edge —
  // same interaction as VS Code's chat/sidebar panel
  const [panelWidth, setPanelWidth] = useState(395);
  const isResizingRef = useRef(false);

  const startPanelResize = (e) => {
    e.preventDefault();
    isResizingRef.current = true;
    document.body.style.cursor = "col-resize";
    document.body.style.userSelect = "none";
  };

  useEffect(() => {
    const onMouseMove = (e) => {
      if (!isResizingRef.current) return;
      const newWidth = window.innerWidth - e.clientX;
      const maxWidth = Math.min(900, window.innerWidth - 100);
      const clampedWidth = Math.min(Math.max(newWidth, 320), maxWidth);
      setPanelWidth(clampedWidth);
      // Keep the report/content area's right margin in sync live, not just on toggle,
      // so it resizes together with the panel as it's dragged left/right
      $("#main").css("marginRight", `${clampedWidth}px`);
      document.documentElement.style.setProperty("--comments-panel-offset", `${clampedWidth}px`);
    };
    const onMouseUp = () => {
      if (!isResizingRef.current) return;
      isResizingRef.current = false;
      document.body.style.cursor = "";
      document.body.style.userSelect = "";
    };
    document.addEventListener("mousemove", onMouseMove);
    document.addEventListener("mouseup", onMouseUp);
    return () => {
      document.removeEventListener("mousemove", onMouseMove);
      document.removeEventListener("mouseup", onMouseUp);
    };
  }, []);

  const email = localStorage.getItem("myemail");
  const userNameLocal = localStorage.getItem("userName");
  const navigate = useNavigate();

  // Parse first and last name from userName
  const getNameParts = () => {
    if (!userNameLocal) return { firstName: "User", lastName: "", initials: "U" };
    const nameParts = userNameLocal.trim().split(/\s+/);
    const firstName = nameParts[0] || "User";
    const lastName = nameParts.length > 1 ? nameParts[nameParts.length - 1] : "";
    const initials = lastName ? `${firstName.charAt(0)}${lastName.charAt(0)}` : firstName.charAt(0);
    return { firstName, lastName, initials };
  };

  const { firstName, lastName, initials } = getNameParts();

  // Force !important so this beats the global "a:hover { color: white !important; }" rule in App.css
  const handleMenuItemHover = (e) => {
    e.currentTarget.style.setProperty("background-color", "var(--app-header-menu-hover)", "important");
    e.currentTarget.style.setProperty("color", "#475569", "important");
  };
  const handleMenuItemLeave = (e) => {
    e.currentTarget.style.setProperty("background-color", "transparent", "important");
    e.currentTarget.style.setProperty("color", "#475569", "important");
  };

  const logout = async () => {
    try {
      await instance.logoutRedirect({
        postLogoutRedirectUri: `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`,
      });
    } catch (error) {
      console.error("Logout failed", error);
      window.location.href = `${process.env.REACT_APP_SSO_LOGOUT_REDIRECT_URL}`;
    }
  };

  const switchPersona = () => {
    setSwitching(true);
    setopenDialog(false);

    if (CheckGroupId.includes(104)) updateRLtype();

    updateDefaultUserGroup(email, personaId)
      .then(() => {
        setSwitching(false);
        setpersonaId();
        setpersonaName("");
        navigate("/");
        window.location.reload();
      })
      .catch(() => {
        setSwitching(false);
      });
  };

  const [selectedItem, setSelectedItem] = useState("");
  const [RLLoading, SetRLLoading] = useState(true);

  const updateRLtype = () => {
    updateDefaultRlType(selectedItem).catch((error) => {
      console.log(error);
    });
  };
  useEffect(() => {
    let isMounted = true;
    const fetchToken = async () => {
      try {
        await getToken();
      } catch (error) {
        if (isMounted) console.error("Failed to acquire token", error);
      }
    };
    fetchToken();
    return () => {
      isMounted = false;
    };
  }, [instance]);

  useEffect(() => {
    fetchUserGroupList()
      .then((json) => {
        const userGroupIds = json.map((item) => item.userGroupId);
        setCheckGroupId(userGroupIds);
      })
      .catch(() => {});
  }, [fetchUserGroupList]);

  // console.log(CheckGroupId)

  useEffect(() => {
    fetchUserDetails()
      .then((json) => {
        const defaultData = json;
        const defaultRLData = defaultData?.defaultRlType;
        const defaultRLDataLsitId = defaultData?.defaultUserGroup;
        const userTypeData = defaultData?.userType;

        setSelectedItem(defaultRLData);
        SetRLLoading(false);
        localStorage.setItem("userGroup", defaultRLDataLsitId);
        localStorage.setItem("RLTYPE", defaultRLData);
        localStorage.setItem("userType", userTypeData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [fetchUserDetails]);

  // Pages + features granted via Tool Roles (Page Management) — additive to the Admin flag
  useEffect(() => {
    ensureLoaded().catch(() => {});
  }, [ensureLoaded]);

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setMenuOpen(false);
      }
    };

    if (menuOpen) {
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
  }, [menuOpen]);

  
  return (
    <>
      <Navbar
        id="mainNavbar"
        style={{
          paddingLeft: "2rem",
          paddingRight: "2rem",
          justifyContent: "space-between",
          border: "1px solid #D9D9D9",
          left: "80px"
        }}
        className="nav_bar navFlexbox"
        expand="lg"
        variant="light"
        fixed="top"
      >
        <div className="nav-items logo-placement">
          <MenuOpenIcon
            onClick={menubar}
            style={{ color: uiConfig.iconColor, fontSize: 24, cursor: "pointer" }}
          />

          <Navbar.Brand
            style={{
              marginLeft: uiConfig.headerBrandTextMarginLeft ?? 16,
              fontWeight: 700,
              color: uiConfig.headerBrandTextColor,
            }}
          >
            {uiConfig.headerTitle ? (
          <div className="font-bold" style={{ color: uiConfig.headerBrandTextColor, marginLeft: uiConfig.headerBrandTextMarginLeft ?? 10, fontWeight: "700", fontSize: "20px", lineHeight: "normal", letterSpacing: "1.1px", marginBottom: "0px", textTransform: "uppercase" }}>

            <span>{uiConfig.headerTitle}</span>
          </div>
        ) : null}
          </Navbar.Brand>
        </div>
        

        <div
          style={{ background: "transparent", gap: "20px" }}
          className="nav-items items-center justify-end"
        >
          {featureFlags.Notifications && <Notifications />}

          {featureFlags.Bookmark && <Bookmark />}

          {featureFlags.Comments && reportId && pageLoad && (
              

            <button
              className="relative flex items-center justify-center w-9 h-9 rounded-full hover:bg-gray-100 transition-colors"
              id="notificationIDclick"
              onClick={notifications}
              type="button"
              aria-label="Open comments"
            >
              <EditNoteIcon
                style={{ fontSize: 27, cursor: "pointer", color: 'var(--app-icon-color, #bb1ccc)' }}
              />
            </button>
          )}


          <Box
            ref={menuRef}
            sx={{ display: "flex", alignItems: "center", textAlign: "center", position: "relative" }}
          >
            <Tooltip title="Account settings">
              <IconButton
                onClick={() => setMenuOpen(!menuOpen)}
                size="small"
                sx={{ display: "flex", alignItems: "center", gap: "4px" }}
              >
                <div
                >
                
                  <Avatar
                    sx={{
                      width: 36,
                      height: 36,
                      background: uiConfig.tableAccentGradient,
                      color: "white",
                      fontWeight: "600",

                    }}
                  >
                    <span className="text-[14px]"> {initials}</span>
                  </Avatar>


               
                </div>
                <KeyboardArrowDownIcon
                  sx={{
                    color: uiConfig.iconColor || "#A70E13",
                    transition: "transform 0.2s ease",
                    transform: menuOpen ? "rotate(180deg)" : "rotate(0deg)",
                  }}
                />
              </IconButton>
            </Tooltip>

            {/* User Menu Dropdown */}
            {menuOpen && (
              <div
                className="absolute right-0 mt-2 w-64 bg-white border border-slate-200 rounded-lg shadow-lg overflow-hidden"
                data-testid="user-menu-dropdown"
                style={{
                  position: "absolute",
                  right: 0,
                  top: "100%",
                  marginTop: "8px",
                  width: "256px",
                  backgroundColor: "white",
                  border: "1px solid #e2e8f0",
                  borderRadius: "8px",
                  boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
                  overflow: "hidden",
                  zIndex: 1000,
                }}
              >
                {/* User Info Section */}
                <div
                  style={{
                    padding: "12px 16px",
                    borderBottom: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <AccountCircleIcon
                      sx={{
                        fontSize: "32px",
                        color: "#002FA7",
                        minWidth: "32px",
                      }}
                    />
                    <div style={{ flex: 1, minWidth: 0, justifyContent: "flex-start", display: "flex", flexDirection: "column",textAlign: "left" }}>
                      <p
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#1e293b",
                          margin: 0,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        data-testid="user-name"
                      >
                        {firstName} {lastName}
                      </p>
                      <p
                        style={{
                          fontSize: "12px",
                          color: "#64748b",
                          margin: 0,
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          whiteSpace: "nowrap",
                        }}
                        data-testid="user-email"
                      >
                        {email || ""}
                      </p>
                    </div>
                  </div>
                </div>

                {/* Admin Menu Items — visibility strictly governed by Tool Role page assignments */}
                {(() => {
                  const canSee = (pageKey) => assignedPageKeys.includes(pageKey);
                  const hasAnyMenuItem =
                    canSee("/UserAdministration") ||
                    canSee("/ReportAdministration") ||
                    canSee("/PersonaAdministration") ||
                    canSee("/RolesAdministration") ||
                    canSee("/PageManagement");

                  if (!hasAnyMenuItem) return null;

                  return (
                  <div style={{ padding: "8px 0", borderBottom: "1px solid #f1f5f9" }}>
                    {/* Access Management */}
                    {canSee("/UserAdministration") && (
                    <Link
                      to="/UserAdministration"
                      onClick={() => setMenuOpen(false)}
                      data-testid="nav-link-access-management"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 16px",
                        fontSize: "14px",
                        color: "#475569",
                        textDecoration: "none",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={handleMenuItemHover}
                      onMouseLeave={handleMenuItemLeave}
                    >
                      <FaUsersCog size={16} />
                      <span>Access Management</span>
                    </Link>
                    )}

                    {/* Report Management */}
                    {canSee("/ReportAdministration") && (
                    <Link
                      to="/ReportAdministration"
                      onClick={() => setMenuOpen(false)}
                      data-testid="nav-link-report-management"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 16px",
                        fontSize: "14px",
                        color: "#475569",
                        textDecoration: "none",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={handleMenuItemHover}
                      onMouseLeave={handleMenuItemLeave}
                    >
                      <DescriptionIcon sx={{ fontSize: "16px" }} />
                      <span>Report Management</span>
                    </Link>
                    )}

                    {/* Persona Management */}
                    {canSee("/PersonaAdministration") && (
                    <Link
                      to="/PersonaAdministration"
                      onClick={() => setMenuOpen(false)}
                      data-testid="nav-link-persona-management"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 16px",
                        fontSize: "14px",
                        color: "#475569",
                        textDecoration: "none",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={handleMenuItemHover}
                      onMouseLeave={handleMenuItemLeave}
                    >
                      <FaUserPlus size={16} />
                      <span>Persona Management</span>
                    </Link>
                    )}

                    {/* RLS Management */}
                    {canSee("/RolesAdministration") && (
                    <Link
                      to="/RolesAdministration"
                      onClick={() => setMenuOpen(false)}
                      data-testid="nav-link-rls-management"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 16px",
                        fontSize: "14px",
                        color: "#475569",
                        textDecoration: "none",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={handleMenuItemHover}
                      onMouseLeave={handleMenuItemLeave}
                    >
                      <FaShieldAlt size={16} />
                      <span>RLS Management</span>
                    </Link>
                    )}

                    {/* Page Management */}
                    {canSee("/PageManagement") && (
                    <Link
                      to="/PageManagement"
                      onClick={() => setMenuOpen(false)}
                      data-testid="nav-link-page-management"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "8px",
                        padding: "10px 16px",
                        fontSize: "14px",
                        color: "#475569",
                        textDecoration: "none",
                        transition: "background-color 0.2s",
                      }}
                      onMouseEnter={handleMenuItemHover}
                      onMouseLeave={handleMenuItemLeave}
                    >
                      <FaThLarge size={16} />
                      <span>Page Management</span>
                    </Link>
                    )}
                  </div>
                  );
                })()}

                {/* Logout Button */}
                <button
                  onClick={logout}
                  style={{
                    width: "100%",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                    padding: "10px 16px",
                    fontSize: "14px",
                    color: "#475569",
                    backgroundColor: "transparent",
                    border: "none",
                    cursor: "pointer",
                    textAlign: "left",
                    transition: "background-color 0.2s",
                  }}
                  data-testid="logout-button"
                  onMouseEnter={handleMenuItemHover}
                  onMouseLeave={handleMenuItemLeave}
                >
                  <LogoutIcon sx={{ fontSize: "16px" }} />
                  <span>Sign out</span>
                </button>
              </div>
            )}
          </Box>

        
        </div>
      </Navbar>

      <div id="NotificationsIdValues" className="notificationsCss" style={{ width: panelWidth }}>
        <div className="notifications-resize-handle" onMouseDown={startPanelResize} />
        <ChatRoomNew
          title={title}
          guid={guid}
          reportId={reportId}
          pageName={pageName}
          groupId={groupId}
        />
      </div>

      {/* <div id="NotesValues" className="notificationsCss">
        <Notifications />
      </div> */}

      <Dialog
        open={openDialog}
        onClose={() => setopenDialog(!openDialog)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle
          style={{ background: "#A70E13", color: "#fff", fontWeight: "500" }}
          id="alert-dialog-title"
        >
          {"Switching Persona!!"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            style={{ marginTop: "16px", color: "#8A9295" }}
          >
            <>Do you wish to switch to {personaName}?</>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button
            className="submit_btn"
            style={{ width: "auto" }}
            onClick={switchPersona}
            autoFocus
            disabled={personaId !== 104 ? false : RLLoading}
          >
            Yes
          </Button>

          <Button
            className="cancel_btn"
            style={{ width: "auto" }}
            onClick={() => setopenDialog(false)}
          >
            No
          </Button>
        </DialogActions>
      </Dialog>

      {Switching && (
        <div
          style={{ fontSize: "18px", fontWeight: "600" }}
          className="switchingClass"
        >
          <div
            style={{
              position: "fixed",
              background: "rgba(0,0,0,0.8)",
              width: "100%",
              height: "100%",
              top: "0",
              left: "0",
              right: "0",
              bottom: "0",
              display: "grid",
              justifyContent: "center",
              alignItems: "center",
              color: "white",
              zIndex: "99999",
              justifyItems: "center",
              alignContent: "center",
            }}
          >
            <img width={200} src={preloadimg} alt="Loading" />
            <span>Switching to {personaName}</span>
          </div>
        </div>
      )}
    </>
  );
};

export default NavHeader;
